import gql from "graphql-tag";
import { countryFragments } from "./Country";
import { workRelationFragments } from "./WorkRelation";

const employeeTaxCardsFragments = gql`
  fragment employeeTaxCardsFragments on EmployeeTaxCard {
    id
    fetchedAt
    taxTable
    taxPercentage
    taxExemption
    file {
      id
      signedBlobId
      fileName
      url
    }
    calendarYear
    taxExemptionAmountLimit
    taxDeductionMethod
  }
  ${countryFragments}
`;

export const employeeFragments = gql`
  fragment employeeFragments on Employee {
    id
    firstName
    lastName
    birthDate

    user {
      id
      login
      cellphone
      cellphoneCountry {
        ...countryFragments
      }
    }
    phone
    phoneCountry {
      ...countryFragments
    }

    address
    city
    zip
    country {
      ...countryFragments
    }

    postboxCity
    postboxNumber
    postboxPlace
    postboxZip
    birthDateMismatchReason

    bban
    iban
    swift
    socialSecurityNumber
    temporarySocialSecurityNumber
    vacationMoneyPercentage
    creditDays

    employeeTaxCards {
      ...employeeTaxCardsFragments
    }

    workRelations {
      ...workRelationFragments
    }
  }
  ${countryFragments}
  ${employeeTaxCardsFragments}
  ${workRelationFragments}
`;
